module.exports = __webpack_public_path__ + "images/apple-touch-icon-120-e3f82ac3.png";